// extracted by mini-css-extract-plugin
module.exports = {"image":"BadgeImage-module__image___1OkSK","large":"BadgeImage-module__large___pRrtv","clickable":"BadgeImage-module__clickable___2RX-5"};